  import React from "react";
  import { MentionsInput, Mention } from "react-mentions";
  import { Popover } from "antd";
  import Picker from "@emoji-mart/react";
  import data from "@emoji-mart/data";
  import SendInbox from "../../../../assets/customSVG/inbox/SendInbox";
  import InboxNoteIcon from "../../../../assets/customSVG/inbox/InboxNoteIcon";
  import { getRandomColorsBassedOnLetters } from "../../../../helper/colors";
  import Loader from "../../../../components/commonComponents/Loader/Index";

  const defaultStyle = {
    control: {
      backgroundColor: "transparent",
      fontSize: "0.85rem",
      fontWeight: 400,
    },
    highlighter: {
      overflow: "hidden",
    },
    input: {
      margin: 0,
      overflow: "auto",
    },
    "&multiLine": {
      control: {
        fontFamily: "inherit",
        minHeight: 50, // Reduced from 63
        maxHeight: 100, // Reduced from 200 (approx 1/3 less)
        overflowY: 'auto',
      },
      highlighter: {
        padding: 9,
        minHeight: 50,
        maxHeight: 100, // Reduced to match
        overflow: 'hidden',
      },
      input: {
        padding: 9,
        minHeight: 50, // Reduced
        maxHeight: 100, // Reduced
        outline: 0,
        border: 0,
        overflowY: 'auto',
      },
    },
    suggestions: {
      bottom: "0",
      top: "unset",
      list: {
        backgroundColor: "white",
        border: "1px solid rgba(0,0,0,0.15)",
        fontSize: 14,
        minHeight: 50,
        maxHeight: 100, // Reduced
        overflowY: "auto",
      },
      item: {
        padding: "5px 10px",
      },
    },
  };

  const defaultMentionStyle = {
    backgroundColor: "#ffe68a",
  };

  export default function NoteEditor({
    noteContent,
    setNoteContent,
    showEmojiPickerCaption,
    setShowEmojiPickerCaption,
    handleNoteEmojiClick,
    noteCreate,
    textareaRef,
    noteUpdate,
    handleChat,
    assignGetData,
    isNoteLoading,
  }) {

    const renderSuggestion = (
      entry,
      search,
      highlightedDisplay,
      index,
      focused
    ) => {
      const initials = entry.display
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase();

      return (
        <div
          className={`flex items-start gap-2 p-2 ${focused ? "bg-gray-200" : ""}`}
        >
          <div
            className="w-9 h-9 rounded-full border-[2px] border-white text-[0.65rem] font-[600] flex items-center justify-center"
            style={{
              color: "white",
              backgroundColor: getRandomColorsBassedOnLetters(
                initials,
                1.5
              ).backgroundColor,
            }}
          >
            {initials}
          </div>
          <div className="text-left">
            <div className="text-sm text-black font-medium">{entry.display}</div>
            <div className="text-xs text-gray-500">{entry.email}</div>
          </div>
        </div>
      );
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        if (noteContent?.id) {
          noteUpdate();
        } else {
          noteCreate();
        }
      }
    };

    return (
      <div
        className="w-full p-2 bg-[#FFF7D9] pb-2 rounded-[0.7vw] flex flex-col gap-[0.3vw]"
        style={{
          // minHeight: "6vh", // Reduced from 9vh
          // maxHeight: "26vh", // Reduced from 40vh
          border: "1px solid rgb(255 199 4 / 41%)",
        }}
      >
        <MentionsInput
          value={noteContent.content}
          onChange={(e) =>
            setNoteContent({ content: e.target.value, id: noteContent?.id })
          }
          onKeyDown={handleKeyDown}
          placeholder="Write your notes"
          style={defaultStyle}
          markup="[__display__](__id__)"
          displayTransform={(id, display) => `@${display}`}
          allowSpaceInQuery
          multiLine={true}
        >
          <Mention
            trigger="@"
            data={(search) =>
              assignGetData
                .filter((member) => matchUser(search, member))
                .map((member) => ({
                  id: member.id,
                  display: member.full_name,
                  email: member.email,
                }))
            }
            renderSuggestion={renderSuggestion}
            style={defaultMentionStyle}
            appendSpaceOnAdd={true}
          />
        </MentionsInput>

        {/* Rest of the component remains exactly the same */}
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-[0.5vw]">
            <div className="border-r border-gray-300 pr-2">
              <button
                className="flex items-center gap-[0.3vw] text-[#F59E0B] px-[0.8vw] py-[0.4vw] rounded-[0.3vw] hover:bg-[#fae4be] transition-colors duration-200"
                onClick={handleChat}
              >
                <InboxNoteIcon fill="#F59E0B"/>
                <span className="text-[#F59E0B] font14px-400">Go to Chat</span>
              </button>
            </div>

            <Popover
              trigger={["click"]}
              open={showEmojiPickerCaption}
              onOpenChange={(open) => setShowEmojiPickerCaption(open)}
              arrow={false}
              content={
                <Picker
                  data={data}
                  onEmojiSelect={(emoji) => {
                    handleNoteEmojiClick(emoji)
                  }}
                />
              }
            >
              <button
                className="size-[1.5vw] flex items-center justify-center rounded-[0.4vw] p-[0.5vw] hover:bg-slate-100"
                type="button"
                onClick={() => setShowEmojiPickerCaption(!showEmojiPickerCaption)}
              >
                😊
              </button>
            </Popover>
          </div>

          {isNoteLoading ? (
            <div className="flex items-center justify-center px-[0.6vw] py-[0.2vw] rounded-[0.3vw] bg-[#F59E0B] min-w-[80px] min-h-[32px]">
              <Loader Width={20} Height={20} loaderBg="white" />
            </div>
          ) : noteContent?.id ? (
            <button
              onClick={noteUpdate}
              className="bg-[#F59E0B] text-white px-[0.6vw] py-[0.2vw] rounded-[0.3vw] flex items-center gap-[0.3vw] font16px-400"
              disabled={isNoteLoading}
            >
              Update
              <SendInbox color="white" width="1vw" height="1vw" />
            </button>
          ) : (
            <button
              onClick={noteCreate}
              className="bg-[#F59E0B] text-white px-[0.6vw] py-[0.2vw] rounded-[0.3vw] flex items-center gap-[0.3vw] font16px-400"
              disabled={isNoteLoading}
            >
              Create
              <SendInbox color="white" width="1vw" height="1vw" />
            </button>
          )}
        </div>
      </div>
    );
  }

  // Keep the existing matchUser function
  const matchUser = (search, member) => {
    const cleanSearch = search.toLowerCase().replace(/^@/, "");
    const name = member.full_name?.toLowerCase() || "";
    const email = member.email?.toLowerCase() || "";

    return (
      name.includes(cleanSearch) ||
      email.includes(cleanSearch) ||
      cleanSearch.split(" ").every((term) => name.includes(term) || email.includes(term))
    );
  };